'use client';

import { useEffect } from 'react';

const CLARITY_PROJECT_ID = 'tb62p0btqk';

export function AnalyticsBootstrap() {
  useEffect(() => {
    const win = window as any;
    win.RudderSnippetVersion = '3.2.0';

    const identifier = 'rudderanalytics';
    if (!Array.isArray(win[identifier])) {
      win[identifier] = [];
    }

    const rudderanalytics = win[identifier] as Array<unknown> & {
      snippetExecuted?: boolean;
      [key: string]: unknown;
    };

    if (rudderanalytics.snippetExecuted !== true) {
      rudderanalytics.snippetExecuted = true;
      win.rudderAnalyticsBuildType = 'legacy';

      const methods = [
        'setDefaultInstanceKey',
        'load',
        'ready',
        'page',
        'track',
        'identify',
        'alias',
        'group',
        'reset',
        'setAnonymousId',
        'startSession',
        'endSession',
        'consent',
        'addCustomIntegration',
      ] as const;

      for (const method of methods) {
        rudderanalytics[method] = (...args: unknown[]) => {
          if (Array.isArray(win[identifier])) {
            rudderanalytics.push([method, ...args]);
            return;
          }
          const current = win[identifier] as Record<string, unknown>;
          const fn = current[method];
          if (typeof fn === 'function') {
            fn(...args);
          }
        };
      }
    }

    const hasClarityScript = document.querySelector(
      `script[data-clarity-id="${CLARITY_PROJECT_ID}"]`,
    );
    if (!hasClarityScript) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
      script.setAttribute('data-clarity-id', CLARITY_PROJECT_ID);
      document.head.appendChild(script);
    }
  }, []);

  return null;
}
